const getters = {
  productFilterList: (state) => state.user.productFilterList,
  baList: (state) => state.user.baList,
  storeStateList: (state) => state.user.storeStateList
}

export default getters
